export default __webpack_public_path__ + "static/media/11.67a88abe.jpeg";